import React from "react";

const SuccessPage = () => {
  return <div>Succesfully Edited</div>;
};

export default SuccessPage;
